'use strict'

module.exports = function ajax(opt) {

	const options = {
		method: opt.method || 'GET',
		url: opt.url || '/',
		data: opt.data || null,
	}
	const json = opt.dataType === 'application/json'

	const xhr = new XMLHttpRequest()
	xhr.open(options.method, options.url)
	if (json) {
		xhr.setRequestHeader('Content-Type', opt.dataType)
		options.data = JSON.stringify(options.data)
	}
	xhr.send(options.data)

	let type

	return new Promise((fulfill, reject) => {

		xhr.onreadystatechange = () => {
			const HEADERS = 3
			const DONE = 4
			const OK = 200

			if (xhr.readyState === HEADERS) {
				type = xhr.getResponseHeader('Content-Type')
			}
			if (xhr.readyState === DONE) {
				if (xhr.status === OK) {
					if (type && type.match('application/json')) {
						fulfill(JSON.parse(xhr.responseText))
						return
					}
					fulfill(xhr.responseText)
				} else {
					if (xhr.status === 401) {
						reject()
						window.location = '/login'
						return
					}
					reject(JSON.parse(xhr.responseText))
				}
			}
		}

	})


}



//////////////////
// WEBPACK FOOTER
// ./src/helpers/ajax.js
// module id = 4
// module chunks = 0